var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeemgIconsCreatorCamera2023(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#333333;}\r\n\t.st1{fill:#C60505;}\r\n\t.st2{fill:#FF8500;}\r\n\t.st3{fill:#BF2B2B;}\r\n\t.st4{fill:#FFFFFF;}\r\n\t.st5{fill:#383838;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M16,12.73c2.54,0,4.61,2.07,4.61,4.61c0,0.16,0.13,0.29,0.29,0.29s0.29-0.13,0.29-0.29 c0-2.87-2.33-5.2-5.2-5.2c-0.16,0-0.29,0.13-0.29,0.29C15.71,12.6,15.84,12.73,16,12.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M28.06,7.29h-4.15l-2.79-2.53c-0.11-0.1-0.25-0.15-0.4-0.15h-9.46c-0.15,0-0.29,0.05-0.4,0.15L8.08,7.29H7.18 v-1.3c0-0.33-0.27-0.59-0.59-0.59H4.69C4.36,5.4,4.1,5.66,4.1,5.99v1.3H3.94c-1.29,0-2.33,1.05-2.33,2.33v15.45 c0,1.29,1.05,2.33,2.33,2.33h24.12c1.29,0,2.33-1.05,2.33-2.33V9.62C30.39,8.33,29.35,7.29,28.06,7.29z M4.98,6.28h1.3v1.3h-1.3 V6.28z M4.69,8.47h1.89h1.73c0.15,0,0.29-0.05,0.4-0.15l2.79-2.53h9l2.79,2.53c0.11,0.1,0.25,0.15,0.4,0.15h4.37 c0.63,0,1.14,0.51,1.14,1.14v15.45c0,0.63-0.51,1.14-1.14,1.14H3.94c-0.63,0-1.14-0.51-1.14-1.14V9.62c0-0.63,0.51-1.14,1.14-1.14 H4.69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M27.62,10.54h0.04c0.33,0,0.59-0.27,0.59-0.59c0-0.33-0.27-0.59-0.63-0.59c-0.33,0-0.59,0.27-0.59,0.59 C27.03,10.27,27.29,10.54,27.62,10.54z M27.66,9.65c0.16,0,0.29,0.13,0.29,0.29c0,0.16-0.13,0.29-0.29,0.29h-0.04 c-0.16,0-0.29-0.13-0.29-0.29C27.33,9.78,27.46,9.65,27.66,9.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M16,25.01c4.23,0,7.67-3.44,7.67-7.67S20.23,9.68,16,9.68c-4.23,0-7.67,3.44-7.67,7.67S11.77,25.01,16,25.01z  M16,10.86c3.57,0,6.48,2.91,6.48,6.48s-2.91,6.48-6.48,6.48s-6.48-2.91-6.48-6.48S12.43,10.86,16,10.86z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeemgIconsCreatorCamera2023);
export default __webpack_public_path__ + "static/media/beemg-icons-creator-camera-2023.7f7bef14aeeda42088aa9bb7c1ddbfd2.svg";
export { ForwardRef as ReactComponent };